import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {ItemModule} from '../../../../../../core/component/item/item.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MultipleSelectFilterDataModule} from '../../../../../../core/component/multiple-select-filter-data/multiple-select-filter-data.module';
import {MedicalRecordProblemMultipleSelectFilterComponent} from './medical-record-problem-multiple-select-filter.component';
import {
    MedicalRecordProblemCreateUpdateModule
} from '../medical-record-problem-create-update/medical-record-problem-create-update.module';

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        ReactiveFormsModule,
        FormsModule,
        ItemModule,
        MultipleSelectFilterDataModule,
        MedicalRecordProblemCreateUpdateModule,
    ],
    declarations: [
        MedicalRecordProblemMultipleSelectFilterComponent,
    ],
    exports: [
        MedicalRecordProblemMultipleSelectFilterComponent
    ],
})
export class MedicalRecordProblemMultipleSelectFilterModule {
}
